import { Title } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { useGetRolesQuery } from 'domains/Configurations/Users/usersApi';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import {
  PartnersListMobileRow,
  PartnersListMobileSkeleton,
} from './components';
import { usePartnersList } from '../../hooks';

function PartnersListMobile() {
  const { data: partners, isLoading: isPartnersLoading } = usePartnersList();
  const t = useTranslationConfigurations('partnersListComponent');
  const { data: storeRoles, isLoading: isRolesLoading } = useGetRolesQuery();

  const showSkeleton = isPartnersLoading || isRolesLoading;

  const allRoles = { ...storeRoles?.roles, ...storeRoles?.appRoles };

  if (showSkeleton) return <PartnersListMobileSkeleton />;
  if (!partners || partners?.length === 0) return null;

  return (
    <>
      <Title as="h4">{t('title')}</Title>
      <DataList>
        <DataList.Row topDivider={false} padding="small">
          {partners?.map((partner) => (
            <PartnersListMobileRow
              key={`partners-list-item-${partner.partnerId}`}
              partner={partner}
              storeRoles={allRoles}
            />
          ))}
        </DataList.Row>
      </DataList>
    </>
  );
}

export default PartnersListMobile;
